import { useGetRenkiTag } from 'gen/client';

interface HttpLikeError {
    code?: number; // sometimes libraries use code for status codes
    // Orval generated UtilHttpError only has message, but runtime fetcher may attach code or status.
    message?: string;
    status?: number; // optional augmentation
}

function isNotFound(e: unknown): boolean {
    if (!e) {
        return false;
    }
    const err = e as HttpLikeError;
    if (typeof err.status === 'number' && err.status === 404) {
        return true;
    }
    if (typeof err.code === 'number' && err.code === 404) {
        return true;
    }
    // Fallback: inspect message
    if (typeof err.message === 'string' && /404|not found/i.test(err.message)) {
        return true;
    }
    return false;
}

export function useTagExists(serial: string) {
    const { data, error, isLoading, mutate } = useGetRenkiTag(serial, {
        swr: {
            enabled: Boolean(serial),
            // Fetch only once: disable all automatic revalidations and retries.
            refreshInterval: 0,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            shouldRetryOnError: false,
        },
    });
    const exists = Boolean(data);
    const tagNotAdded = isNotFound(error);
    return { data, error, exists, isLoading, mutate, tagNotAdded };
}
